/**
 * Regex for customer info form validation
 */
const CommonRegexForFirstNLastNCity = /^[\p{L}\s.'-]+$/u;
const customerInfoRegexOList = {
  firstName: CommonRegexForFirstNLastNCity,
  lastName: CommonRegexForFirstNLastNCity,
  emailAddress:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phoneNumber:
    /^\(?([2-9][0-8][0-9])\)?[ . ]?([2-9][0-9]{2})[-. ]?([0-9]{4})(\s*x[0-9]+)?$/,
  zipcode: /\b\d{5}\b/g,
  city: CommonRegexForFirstNLastNCity,
};

/**
 * static values interface for customer info form
 */
export interface ICustomerInfoConstantsInputsProperties {
  type: string;
  id: string;
  name: string;
  required: boolean;
  label: string;
  placeHolder: string;
  requiredMsg: string;
  errorMsg: string;
  maxCharLength?: number;
  regex?: RegExp;
}

interface IcustomerInfoConstantsInputs {
  [key: string]: ICustomerInfoConstantsInputsProperties;
}
interface IcustomerInfoConstants {
  inputs: IcustomerInfoConstantsInputs;
}

/**
 * static values for customer info form
 */

const genericErrorMsg = 'Please remove invalid characters';
export const customerInfoConstants: IcustomerInfoConstants = {
  inputs: {
    firstName: {
      type: 'text',
      id: 'billing_addressfirstname',
      name: 'firstName',
      required: true,
      label: 'First Name *',
      placeHolder: 'First Name *',
      requiredMsg: 'Enter your first name',
      errorMsg: genericErrorMsg,
      regex: customerInfoRegexOList.firstName,
      maxCharLength: 50,
    },
    lastName: {
      type: 'text',
      id: 'billing_addresslastname',
      name: 'lastName',
      required: true,
      label: 'Last Name *',
      placeHolder: 'Last Name *',
      requiredMsg: 'Enter your last name',
      errorMsg: genericErrorMsg,
      regex: customerInfoRegexOList.lastName,
      maxCharLength: 50,
    },
    emailAddress: {
      type: 'email',
      id: 'billing_addressemail',
      name: 'emailAddress',
      required: true,
      label: 'Email Address *',
      placeHolder: 'Email Address *',
      requiredMsg: 'Enter your email address',
      errorMsg: 'Enter a valid email address',
      regex: customerInfoRegexOList.emailAddress,
      maxCharLength: 55,
    },
    phoneNumber: {
      type: 'text',
      id: 'billing_addressphone',
      name: 'phoneNumber',
      required: true,
      label: 'Phone *',
      placeHolder: '(___) ___-____',
      requiredMsg: 'Enter your phone number',
      errorMsg: 'Enter a valid 10-digit phone number',
      regex: customerInfoRegexOList.phoneNumber,
    },
    address: {
      type: 'text',
      id: 'billing_addressaddress',
      name: 'address',
      required: true,
      label: 'Address *',
      placeHolder: 'Address *',
      requiredMsg: 'Enter your street address',
      errorMsg: 'Enter a valid street address',
      maxCharLength: 55,
    },
    apartment: {
      type: 'text',
      id: 'billing_addressapt',
      name: 'apartment',
      required: false,
      label: 'APT #, Unit, Etc. (Optional)',
      placeHolder: 'APT #, Unit, Etc. (Optional)',
      requiredMsg: 'Add unit number if applicable',
      errorMsg: genericErrorMsg,
      maxCharLength: 55,
    },
    zipcode: {
      type: 'text',
      id: 'billing_addresszipcode',
      name: 'zipcode',
      required: true,
      label: 'Zip Code *',
      maxCharLength: 5,
      placeHolder: 'Zip Code *',
      requiredMsg: 'Enter your zip code',
      errorMsg: 'Enter a valid 5-digit zip code',
      regex: customerInfoRegexOList.zipcode,
    },
    city: {
      type: 'text',
      id: 'billing_addresscity',
      name: 'city',
      required: true,
      label: 'City *',
      placeHolder: 'City *',
      requiredMsg: 'Enter your city',
      errorMsg: 'Enter a valid city',
      regex: customerInfoRegexOList.city,
      maxCharLength: 55,
    },
    state: {
      type: 'dropdown',
      id: 'billing_addressstate',
      name: 'state',
      required: true,
      label: 'State *',
      placeHolder: 'Select state',
      requiredMsg: 'Select your state',
      errorMsg: 'Select a valid state',
    },
  },
};
export const zipCodeErrorMessages = {
  invalidZipCodeMessage: 'Enter a valid 5-digit zip code',
};
